import { Trans, useTranslation } from 'react-i18next'
import { useState } from 'react'

import { FundraiserModalProps } from '../FundraiserModalProps.types'

import { AcknowledgeModal, ActionModal, Modal } from '@percent/lemonade'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useMutation } from '@percent/partner-dashboard/common/hooks'

export function ReopenFundraiserModal({ isOpen, onClose, refresh, fundraiser }: Readonly<FundraiserModalProps>) {
  const { t } = useTranslation()
  const { fundraisersService } = useServices()
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)

  const [{ isLoading, data }, { apiFunc: reopenFundraiser }] = useMutation(
    fundraisersService.reopenFundraiser,
    () => {
      setIsSuccess(true)
      refresh()
    },
    () => {
      setIsError(true)
    }
  )

  const handleReopenFundraiser = () => {
    reopenFundraiser(fundraiser.id!)
  }

  const handleCloseSuccessModal = () => {
    setIsSuccess(false)
    onClose()
  }

  const handleCloseErrorModal = () => {
    setIsError(false)
    onClose()
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <>
      {!isSuccess && !isError && (
        <Modal open={isOpen} onClose={handleClose} aria-labelledby="open-reopen-fundraiser">
          <ActionModal
            title={t('dialog.fundraisers.reopen.title')}
            primaryButtonText={t('typography.yesReopen')}
            secondaryButtonText={t('typography.keepFundraiserClosed')}
            handleClose={handleClose}
            handleSubmit={handleReopenFundraiser}
            loading={!!isLoading}
            primaryBtnTestId="btn-reopen-fundraiser"
            disabled={!!isLoading}
          >
            <Trans i18nKey="dialog.fundraisers.reopen.description" />
          </ActionModal>
        </Modal>
      )}
      {data && (
        <Modal open={isSuccess} onClose={handleCloseSuccessModal} aria-labelledby="reopen-fundraiser-success">
          <AcknowledgeModal
            result="positive"
            title={t('dialog.fundraisers.reopen.success.title')}
            description={t('dialog.fundraisers.reopen.success.description')}
            buttonText={t('button.close')}
            handleClose={handleCloseSuccessModal}
            buttonTestId="success-modal-btn"
          />
        </Modal>
      )}
      <Modal open={isError} onClose={handleCloseErrorModal} aria-labelledby="reopen-fundraiser-error">
        <AcknowledgeModal
          result="negative"
          title={t('dialog.fundraisers.reopen.error.title')}
          description={t('dialog.error.description')}
          buttonText={t('button.close')}
          handleClose={handleCloseErrorModal}
          buttonTestId="error-modal-btn"
        />
      </Modal>
    </>
  )
}
